const MS_PER_MINUTE = 60_000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

/**
 * Returns a compact relative time label for support ticket list rows.
 *
 * @param isoTimestamp - ISO-8601 timestamp from the support tickets API.
 * @param now - Reference clock (defaults to current time).
 * @returns User-facing relative or formatted date label.
 */
export function formatSupportTicketTimestamp(
  isoTimestamp: string | null | undefined,
  now: Date = new Date(),
): string {
  if (!isoTimestamp) {
    return "--";
  }

  const parsed = new Date(isoTimestamp);
  if (Number.isNaN(parsed.getTime())) {
    return "--";
  }

  const ms = now.getTime() - parsed.getTime();
  if (ms < MS_PER_MINUTE) {
    return "Just now";
  }

  const minutes = Math.floor(ms / MS_PER_MINUTE);
  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  }

  const hours = Math.floor(ms / MS_PER_HOUR);
  if (hours < 24) {
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  const days = Math.floor(ms / MS_PER_DAY);
  if (days === 1) {
    return "Yesterday";
  }
  if (days < 7) {
    return `${days} days ago`;
  }

  return parsed.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: parsed.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
  });
}
